import { render } from "./Documento.vue?vue&type=template&id=30a54fef&ts=true"
import script from "./Documento.vue?vue&type=script&lang=ts"
export * from "./Documento.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"shared/src/common/infrastructure/componentes/base/common/visor/Documento.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30a54fef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30a54fef', __exports__)) {
    api.reload('30a54fef', __exports__)
  }
  
  module.hot.accept("./Documento.vue?vue&type=template&id=30a54fef&ts=true", () => {
    api.rerender('30a54fef', render)
  })

}


export default __exports__